import { render, staticRenderFns } from "./DoubleGallery.vue?vue&type=template&id=2a5eeb23&"
import script from "./DoubleGallery.vue?vue&type=script&lang=js&"
export * from "./DoubleGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports